import { setIsReports,setIsProjectDetails,downloadMainReport } from "../../store/reports/reportsSlice";
import { useAppDispatch } from "../../store/hooks/StoreHooks";
import { mainReportPayload } from "../../models/Myprojects";

const useReportFacade = () => {
    const dispatch = useAppDispatch();
    const updateIsReport = (payload: boolean) => {
        return dispatch(setIsReports(payload));
    };
    const updateIsProjectDetails = (payload: boolean) => {
        return dispatch(setIsProjectDetails(payload));
    };
    const downloadMainReports = (payload: mainReportPayload) => {
        return dispatch(downloadMainReport(payload));
    };
    return {
        updateIsReport,updateIsProjectDetails,downloadMainReports
    };
};

export default useReportFacade;